// extracted by mini-css-extract-plugin
export default {"connectionStatus":"connectionStatus---QigMt","statusText":"statusText---ZLIXs"};